import { AiOutlineLock } from "react-icons/ai";
import { MdVerified } from "react-icons/md";
import { PiPhoneCallFill } from "react-icons/pi";
import img3 from "../../images/23.png";
import img1 from "../../images/25.png";
import img2 from "../../images/evenement-entreprise.png";

const BenefitsSection = () => {
  const benefits = [
    {
      title: "Paiement sécurisé",
      icon: <AiOutlineLock className="text-3xl text-white sm:text-4xl" />,
      background: "bg-gradient-to-br from-blue-50 to-pink-50",
    },
    {
      title: "Espaces vérifiés",
      icon: <MdVerified className="text-3xl text-white sm:text-4xl" />,
      background: "bg-gradient-to-br from-pink-50 to-purple-50",
    },
    {
      title: "Flexibilité & aide",
      icon: <PiPhoneCallFill className="text-3xl text-white sm:text-4xl" />,
      background: "bg-gradient-to-br from-purple-50 to-blue-50",
    },
  ];

  return (
    <div className="py-16 bg-white md:py-20 lg:py-24 dark:bg-neutral-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header Section */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-pink-50 to-blue-50 rounded-full text-sm font-medium text-pink-600 mb-6">
            <span className="w-2 h-2 bg-pink-500 rounded-full mr-2 animate-pulse"></span>
            Nos avantages
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-neutral-900 dark:text-white mb-6">
            Réservez mieux, vivez plus d'événements
          </h2>
          <p className="text-lg md:text-xl text-neutral-600 dark:text-neutral-400 max-w-3xl mx-auto leading-relaxed">
            Des espaces d'exception pour chaque moment qui compte. Qu'il s'agisse d'un shooting, d'un anniversaire
            ou d'un séminaire, trouvez le lieu parfait.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {/* Image 1 */}
          <div className="group relative overflow-hidden rounded-3xl h-[280px] transform hover:scale-[1.02] transition-transform duration-300">
            <img
              src={img1}
              alt="Meeting Room"
              className="object-cover w-full h-full transform group-hover:scale-105 transition-transform duration-500"
            />
          </div>

          {/* Benefit 1 */}
          <div
            className={`group flex flex-col items-center justify-center ${benefits[0].background} rounded-3xl p-8 h-[280px] transform hover:scale-[1.02] transition-all duration-300 border border-blue-200 dark:border-neutral-600`}
          >
            <div className="flex items-center justify-center w-16 h-16 mb-6 rounded-2xl bg-gradient-to-r from-[#4663ac] to-pink-500 group-hover:scale-110 transition-transform duration-300">
              {benefits[0].icon}
            </div>
            <h3 className="text-xl font-bold text-center text-neutral-900 dark:text-white mb-2">
              {benefits[0].title}
            </h3>
            <p className="text-center text-neutral-600 dark:text-neutral-400 text-sm">
              Transactions sécurisées pour votre tranquillité d'esprit
            </p>
          </div>

          {/* Image 2 */}
          <div className="group relative overflow-hidden rounded-3xl h-[280px] transform hover:scale-[1.02] transition-transform duration-300">
            <img
              src={img2}
              alt="Event Space"
              className="object-cover w-full h-full transform group-hover:scale-105 transition-transform duration-500"
            />
          </div>

          {/* Benefit 2 */}
          <div
            className={`group flex flex-col items-center justify-center ${benefits[1].background} rounded-3xl p-8 h-[280px] transform hover:scale-[1.02] transition-all duration-300 border border-pink-200 dark:border-neutral-600`}
          >
            <div className="flex items-center justify-center w-16 h-16 mb-6 rounded-2xl bg-gradient-to-r from-pink-500 to-purple-500 group-hover:scale-110 transition-transform duration-300">
              {benefits[1].icon}
            </div>
            <h3 className="text-xl font-bold text-center text-neutral-900 dark:text-white mb-2">
              {benefits[1].title}
            </h3>
            <p className="text-center text-neutral-600 dark:text-neutral-400 text-sm">
              Tous nos espaces sont vérifiés et certifiés
            </p>
          </div>

          {/* Image 3 */}
          <div className="group relative overflow-hidden rounded-3xl h-[280px] transform hover:scale-[1.02] transition-transform duration-300">
            <img
              src={img3}
              alt="Professional Event"
              className="object-cover w-full h-full transform group-hover:scale-105 transition-transform duration-500"
            />
          </div>

          {/* Benefit 3 */}
          <div
            className={`group flex flex-col items-center justify-center ${benefits[2].background} rounded-3xl p-8 h-[280px] transform hover:scale-[1.02] transition-all duration-300 border border-purple-200 dark:border-neutral-600`}
          >
            <div className="flex items-center justify-center w-16 h-16 mb-6 rounded-2xl bg-gradient-to-r from-purple-500 to-[#4663ac] group-hover:scale-110 transition-transform duration-300">
              {benefits[2].icon}
            </div>
            <h3 className="text-xl font-bold text-center text-neutral-900 dark:text-white mb-2">
              {benefits[2].title}
            </h3>
            <p className="text-center text-neutral-600 dark:text-neutral-400 text-sm">
              Support client réactif et solutions flexibles
            </p>
          </div>
        </div>

        {/* Bottom Statistics */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="text-center p-6 bg-gradient-to-br from-white to-neutral-50 dark:from-neutral-800 dark:to-neutral-900 rounded-2xl border border-neutral-200 dark:border-neutral-700">
            <div className="text-3xl font-bold text-[#4663ac] mb-2">1000+</div>
            <div className="text-neutral-600 dark:text-neutral-400">Espaces disponibles</div>
          </div>
          <div className="text-center p-6 bg-gradient-to-br from-white to-neutral-50 dark:from-neutral-800 dark:to-neutral-900 rounded-2xl border border-neutral-200 dark:border-neutral-700">
            <div className="text-3xl font-bold text-pink-600 mb-2">5000+</div>
            <div className="text-neutral-600 dark:text-neutral-400">Événements réussis</div>
          </div>
          <div className="text-center p-6 bg-gradient-to-br from-white to-neutral-50 dark:from-neutral-800 dark:to-neutral-900 rounded-2xl border border-neutral-200 dark:border-neutral-700">
            <div className="text-3xl font-bold text-purple-600 mb-2">99%</div>
            <div className="text-neutral-600 dark:text-neutral-400">Satisfaction client</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BenefitsSection;
